export function getSelectedPromotion(state) {
  return state.selected_promotion
}



// WEBPACK FOOTER //
// ./src/modules/promotions/getters.js